<template>
<div>
  <DataNavigation></DataNavigation>
  <VipPrompt :pageModal="page_modal" @pagecancel="pageCancel"></VipPrompt>
  <div class="index_content">
    <Layout>
      <Sider width="208">
        <div class="right_column">
          <p class="top-tip">政策数据</p>
          <div class="keyword-input">
            <Input search enter-button :placeholder="search_phd" v-model="search_ipt" @on-search="handleSearch" />
          </div>
          <div class="rigit_title">
            <span>筛选</span>
            <Dropdown trigger="click" placement="bottom-start" @on-visible-change="handleDropdown" @on-click="haddleScreenDropdown">
              <a href="javascript:void(0)">
                <span>{{screen_active}}</span>
                <Icon type="md-arrow-dropup" v-if="drop_val" />
                <Icon type="md-arrow-dropdown" v-else />
              </a>
              <DropdownMenu slot="list">
                <DropdownItem v-for="(item, sindex) in screen_dropdown" :name="item" :selected="screen_active == item" :key="sindex">{{item}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div class="rigit_content">
            <div class="screen_ul">
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '政策领域'">
                <div class="screen_tle" @click="screenTle.tag_arr = !screenTle.tag_arr">
                  <span>政策领域</span>
                  <Icon type="md-add" v-if="!screenTle.tag_arr" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.tag_arr">
                  <ul class="scr_attention">
                    <CheckboxGroup v-model="params.tag_arr" @on-change="handleChangeOption($event, 'tag_arr')">
                      <li v-for="tItem in dynview_tag_type" :key="tItem.id">
                        <div class="scr_att_tle">
                          <Icon type="md-arrow-dropright" v-if="!screen_sec[tItem.id]" @click="haddleSecSel(tItem.id)" />
                          <Icon type="md-arrow-dropdown" v-else @click="haddleSecSel(tItem.id)" />
                          <span @click="haddleSecSel(tItem.id)">{{tItem.name}}</span>
                        </div>
                        <div class="scr_att_cnt" v-show="screen_sec[tItem.id]">
                          <Checkbox v-for="item in hot_tag_map" :label="item.id" :key="item.id" v-if="item.type_id === tItem.id">
                            <span>{{item.name}} <template v-if="tagNum.length">({{item.id | dealName(tagNum, 'id', 'num', '0')}})</template></span>
                          </Checkbox>
                        </div>
                      </li>
                    </CheckboxGroup>
                  </ul>
                </div>
              </div>

              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '时效性'">
                <div class="screen_tle" @click="screenTle.available = !screenTle.available">
                  <span>时效性</span>
                  <Icon type="md-add" v-if="!screenTle.available" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.available">
                  <RadioGroup v-model="params.available" vertical @on-change="refreshList">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio :label="item" v-for="item,index in available_list" :key="index"><span>{{item}} <template v-if="availableNum.length">({{item | dealName(availableNum, 'available', 'num', '0')}})</template></span></Radio>
                  </RadioGroup>
                </div>
              </div>

              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '有效范围'">
                <div class="screen_tle" @click="screenTle.scope = !screenTle.scope">
                  <span>有效范围</span>
                  <Icon type="md-add" v-if="!screenTle.scope" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.scope">
                  <!-- <RadioGroup
                          v-model="params.scope"
                          vertical
                          @on-change="refreshList"
                      >
                          <Radio label=""><span>不限</span></Radio>
                          <Radio :label="1"><span>全国有效({{wholeScope}})</span></Radio>
                          <Radio :label="2"><span>区域有效({{areasScope}})</span></Radio>
                      </RadioGroup> -->
                  <RadioGroup v-model="params.demostic" vertical @on-change="handleChangeDemostic">
                    <Radio label=""><span>不限</span></Radio>
                    <!-- <Radio :label="0"><span>国外({{foreignNum}})</span></Radio> -->
                    <Radio :label="2"><span>全国有效({{countryNum.num}})</span></Radio>
                    <Radio :label="1"><span>区域有效({{chinaNum}})</span></Radio>
                  </RadioGroup>
                  <div class="sec_options" v-if="params.demostic == 1">
                    <Checkbox v-model="checkAll.address_id" class="all_option" :disabled="checkAll.address_id" @on-change="handleCheckAll('address_id')">
                      <span>全部</span>
                    </Checkbox>
                    <CheckboxGroup v-model="params.address_id" @on-change="handleChangeOption($event, 'address_id')">
                      <Checkbox v-for="(item,index) in city" :label="item.id" :key="index" v-show="index < 10 || showAllAddress">
                        <span>{{item.name}}</span>
                      </Checkbox>
                    </CheckboxGroup>
                    <span class="more_sel" @click="showAllAddress = !showAllAddress">
                      <template v-if="!showAllAddress">查看更多</template>
                      <template v-else>收起更多</template>
                    </span>
                  </div>
                </div>
              </div>
              <div class="screen_li" v-show="screen_active === '全部' || screen_active === '发布时间'">
                <div class="screen_tle" @click="screenTle.time = !screenTle.time">
                  <span>发布时间</span>
                  <Icon type="md-add" v-if="!screenTle.time" />
                  <Icon type="md-remove" v-else />
                </div>
                <div class="screen_cnt" v-show="screenTle.time">
                  <RadioGroup v-model="selTime" vertical @on-change="handleChangeTime">
                    <Radio label=""><span>不限</span></Radio>
                    <Radio v-for="(item, index) in timeOption" :label="item" :key="index">
                      <span>{{item}}({{item | dealName(yearNum, 'year', 'num', '0')}})</span>
                    </Radio>
                    <Radio label="zdy"><span>自定义</span></Radio>
                  </RadioGroup>
                  <div class="zdy_time" v-if="selTime == 'zdy'">
                    <DatePicker type="date" v-model="params.s_time" placeholder="开始时间" :options="startOptions" @on-change="refreshList" :clearable="false"></DatePicker>
                    <DatePicker type="date" v-model="params.e_time" placeholder="结束时间" :options="endOptions" @on-change="refreshList" :clearable="false"></DatePicker>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Sider>
      <Content>
        <div class="top-tip">全部<span v-if="!listLoading">（{{total}}）</span>
          <Dropdown @on-click="haddleChangeSort">
            <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="sel_opt" v-if="haveOption && haveOption.length > 0">
          <div class="sel_tle">已选条件</div>
          <div class="sel_cnt">
            <span v-for="(item,index) in haveOption" :key="index" @click="handleCancelOption(item)">{{item.name}}
              <Icon type="md-close" />
            </span>
          </div>
          <div class="sel_clear">
            <span @click="handleClearOption"><i class="iconfont">&#xe63e;</i>清空筛选</span>
          </div>
        </div>
        <div class="list_div">
          <Table :columns="listColumns" :data="listData"></Table>
          <SearchPrompt v-if="haveOption && haveOption.length > 0 && !isVIP && listData.length == 5 && total > 5"></SearchPrompt>
          <template v-else>
            <div class="page clear" v-if="total > 10">
              <Page :total="total" :page-size="10" :current="params.page" class="page_list" show-total show-elevator ref="pages" @on-change="handleChangePage" />
            </div>
          </template>
          <Spin fix v-if="listLoading">
            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
            <div>Loading</div>
          </Spin>
        </div>
      </Content>
    </Layout>
  </div>
</div>
</template>

<script>
import {
  policyList,
  policyNum,
  tagPolicyNum
} from '../../service'
import {
  idxOf,
  remove,
  removeArrObj
} from 'js/findIndex'
import {
  listMixins
} from 'js/listMixins'
import {
  userInfo
} from 'js/userInfo'
import Nothing from '@/components/Nothing.vue'
import DataNavigation from './components/DataNavigation.vue'
import VipPrompt from '@/components/VipPrompt.vue'
import SearchPrompt from './components/SearchPrompt.vue'
import filter from 'js/filter'
import moment from 'moment'

export default {
  inject: ['login'],
  mixins: [listMixins, userInfo],
  components: {
    Nothing,
    DataNavigation,
    VipPrompt,
    SearchPrompt
  },
  data() {
    return {
      listName: '政策',
      listColumns: [{
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '政策名称',
          minWidth: 200,
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.goPolicyDetail(params.row.uid)
                }
              },
              class: {
                'dec-clamp': true
              }
            }, params.row.name)
          }
        },
        {
          title: '有效地区',
          width: 120,
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.addressDeal(params.row.address_id, '3'))
          }
        },
        {
          title: '发文机关',
          width: 200,
          key: 'publish_org',
          render: (h, params) => {
            return h('div', {
              class: {
                'dec-clamp': true
              }
            }, filter.empty(params.row.publish_org))
          }
        },
        {
          title: '发布时间',
          width: 140,
          render: (h, params) => {
            return h('span', filter.timeTrans(params.row.publish_time))
          }
        }
      ],
      params: {
        demostic: '',
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        keyword: '',
        tag_arr: [],
        available: '',
        sort_type: 0
      },
      available_list: [ '现行有效', '征求意见稿或草案', '尚未生效', '已被修订', '部分失效', '失效'],
      screen_dropdown: ['全部', '政策领域', '时效性', '有效范围', '发布时间'],
      //筛选条件是否展开
      screenTle: {
        tag_arr: false,
        available: false,
        scope: false,
        time: false
      },
      //获投轮次 相关变量
      //不限
      checkAll: {
        address_id: true,
      },
      areasScope: 0,
      wholeScope: 0,
      chinaNum: 0,
      foreignNum: 0,
      yearNum: [],
      tagNum: [],
      countryNum: 0,
      availableNum: [],
      sort_id: 0,
      sort_list: [
        {id: 0, name: '发布时间倒序'},
        {id: 1, name: '发布时间正序'}
      ],
      position_id: '13'
    }
  },
  computed: {
    hos_type() {
      return this.$store.state.hospital_type
    },
    hos_level() {
      return this.$store.state.hos_level
    },
    haveOption() {
      let optionYear = [],
        optionStart = [],
        opitonEnd = [],
        optionAddressId = [],
        optionKeyWord = [],
        optionDemostic = [],
        optionTag = [],
        optionAvailable = []

      if (this.params.available != '') {
        optionAvailable = {
          type: 'available',
          name: this.params.available,
          value: this.params.available
        }
      }
      if (this.hot_tag_map) {
        this.params.tag_arr.map((a) => {
          optionTag.push({
            type: 'tag_arr',
            name: filter.dealName(a, this.hot_tag_map),
            value: a
          })
        })
      }
      if (this.params.year != '' && this.selTime != 'zdy') {
        optionYear = {
          type: 'year',
          name: this.params.year,
          value: this.params.year
        }
      }
      if (this.params.s_time != '') {
        optionStart = {
          type: 's_time',
          name: '开始时间：' + filter.time_moment(this.params.s_time),
          value: this.params.s_time
        }
      }
      if (this.params.e_time != '') {
        opitonEnd = {
          type: 'e_time',
          name: '结束时间：' + filter.time_moment(this.params.e_time),
          value: this.params.e_time
        }
      }
      if (this.params.demostic !== '') {
        optionDemostic = {
          type: 'demostic',
          name: this.params.demostic == 1 ? '区域有效' : '全国有效',
          value: this.params.demostic
        }
      }
      if (this.params.keyword !== '') {
        optionKeyWord = {
          type: 'keyword',
          name: this.params.keyword,
          value: this.params.keyword
        }
      }
      this.params.address_id.map((a) => {
        optionAddressId.push({
          type: 'address_id',
          name: filter.deal(a, 'address'),
          value: a
        })
      })
      return [].concat(
        optionYear,
        optionStart,
        opitonEnd,
        optionDemostic,
        optionKeyWord,
        optionAddressId,
        optionAvailable,
        optionTag
      )
    }
  },
  methods: {
    /**
     * 获取列表
     */
    async getEntityList() {
      this.params.sort_type = this.sort_id
      this.params.user_key = this.user_key
      if(this.params.s_time) {
        this.params.s_time = moment(this.params.s_time).format('YYYY-MM-DD')
      }
      if(this.params.e_time) {
        this.params.e_time = moment(this.params.e_time).format('YYYY-MM-DD')
      }
      this.listLoading = true
      let res = await policyList(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'listData', res.res)
        if (this.params.page == 1) {
          this.$set(this.$data, 'total', Number(res.count))
        }
        this.listLoading = false
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 清空已选择项
     */
    handleClearOption() {
      this.params = {
        demostic: '',
        address_id: [],
        year: '',
        s_time: '',
        e_time: '',
        page: 1,
        keyword: '',
        available: '',
        tag_arr: [],
      }
      this.selTime = ''
      this.search_ipt = ''
      this.getEntityList()
    },
    /**
     * 前往政策详情页
     */
    goPolicyDetail(uid) {
      if (this.$store.state.user_key) {
        // this.$router.push({name: 'PolicyDetail', params: {uid: uid}})
        const {
          href
        } = this.$router.resolve({
          name: "PolicyDetail",
          params: {
            uid: uid
          }
        })
        window.open(href, '_blank')
      } else {
        this.login()
      }
    },
    /**
     * 筛选个数
     */
    async getCount() {
      let res = await policyNum((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'areasScope', res.areas_scope)
        this.$set(this.$data, 'wholeScope', res.whole_scope)
        this.$set(this.$data, 'chinaNum', res.china)
        this.$set(this.$data, 'foreignNum', res.foreign)
        this.$set(this.$data, 'yearNum', res.year)
        this.$set(this.$data, 'availableNum', res.available)
        this.$set(this.$data, 'countryNum', res.country[0])
      } else {
        this.$Message.error(res.message)
      }
    },
    /**
     * 产业领域数量计算-投融资/并购
     */
    async getTagNum(t_arr) {
      let res = await tagPolicyNum({
        tag_arr: t_arr
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.$set(this.$data, 'tagNum', res.res)
      } else {
        this.$Message.error(res.message)
      }
    },
    refreshList() {
      this.params.page = 1
      this.getEntityList()
    }
  },
  created() {
    if (this.$store.state.policy_params != '') {
      this.params = { ...this.$store.state.policy_params }
      this.params.page = 1
      this.sort_id = this.params.sort_type
    }
    this.getMeta()
    this.getEntityList()
    this.getCount()
  },
  mounted() {
    this.$nextTick(() => {
      window.onscroll = () => {
        this.listenerScroll('right_column', 10)
      }
      window.onresize = () => {
        this.listenerScroll('right_column', 10)
      }
    })
  },
  destroyed() {
    window.onscroll = ''
    window.onresize = ''
  },
  beforeDestroy() {
    this.$store.commit('updatePolicyParams', this.params)
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/dataList.stylus'
.list_div
  >>> .ivu-table-wrapper
    .ivu-table
      th:nth-of-type(2)
      td:nth-of-type(2)
        padding-left: 20px
        padding-right: 30px
</style>
